import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { Consultation } from '../types/Consultations/Consultation.type';
import { consultationService } from '../services/consultationService';

import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';

export const useMyConsultations = () => {
    const { t } = useTranslation();
  const [consultations, setConsultations] = useState<Consultation[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isPatientView = searchParams.get('view') === 'patient';
  const { user } = useAuthContext();
  const role: 'patient' | 'professional' = isPatientView ? 'patient' : (user?.type_account === 'professional' ? 'professional' : 'patient');

  useEffect(() => {
    const fetchMyConsultations = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await consultationService.getMyConsultations(role);
        setConsultations(data);
      } catch (err: any) {
        setError(err.message || t('appAdmin.consultationsList.errorText'));
        setConsultations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMyConsultations();
  }, [t, role]);

  return { consultations, loading, error };
};